import gql from 'graphql-tag';

export const CREATE_USER = gql`
    mutation CreateUser(
        $municipality_id: Int!,
        $address: String!,
        $full_name: String!,
        $password_hash: String!,
        $email: String!
    ) {
        createUser(
            email: $email,
            address: $address,
            full_name: $full_name,
            password_hash: $password_hash,
            municipality_id: $municipality_id,
        ) {
            id
            email
            password_hash
            full_name
            address
            is_activate
            municipality_id
            created_at
            updated_at
        }
    }
`;

export const LOGIN_USER = gql`
    mutation LoginUser($email: String!, $password: String!) { 
        loginUser(email: $email, password: $password, source: "web") { 
            id
            token
        } 
    }
`;

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($email: String!, $source: String!) {
    recoverPassword(email: $email, source: $source)
  }
`;

export const NEW_PASSWORD = gql`
  mutation NewPassword($token: String!, $newPassword: String!) {
    newPassword(token: $token, newPassword: $newPassword)
  }
`;
